/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

/** @jsx jsx */

import { jsx } from '@emotion/react'
import { type FunctionComponent } from 'react'

import { EuiPanel, EuiSpacer, EuiText, EuiTitle } from '@elastic/eui'

import { FormattedMessage } from '@modules/i18n'
import { DocLink } from '@modules/doclinks'

import AlertsTable from './AlertsTable'

type Props = {
  organizationId: string
}

const PrepaidConsumption: FunctionComponent<Props> = ({ organizationId }) => (
  <EuiPanel hasBorder={true} hasShadow={false} paddingSize='l'>
    <EuiTitle size='xs'>
      <h3>
        <FormattedMessage
          id='billing.notifications.prepaid-consumption.title'
          defaultMessage='Prepaid consumption credit balance'
        />
      </h3>
    </EuiTitle>
    <EuiSpacer size='s' />
    <EuiText size='s' color='subdued'>
      <FormattedMessage
        id='billing.notifications.prepaid-consumption.description'
        defaultMessage='Get notified when your credit consumption balance reaches certain thresholds. This alert is always active. {learnMore}'
        values={{
          learnMore: (
            <DocLink link='billingFAQUsage' showExternalLinkIcon={true}>
              <FormattedMessage
                id='billing.notifications.prepaid-consumption.description.learn-more'
                defaultMessage='Learn more'
              />
            </DocLink>
          ),
        }}
      />
    </EuiText>

    <EuiSpacer size='m' />
    <AlertsTable organizationId={organizationId} />
  </EuiPanel>
)

export default PrepaidConsumption
